import React from "react";

interface ErrorBannerProps {
  message: string;
  className?: string;
  onDismiss?: () => void;
  "data-testid"?: string;
}

/**
 * A reusable error banner component for displaying error messages consistently across the application.
 */
export function ErrorBanner({
  message,
  className = "",
  onDismiss,
  "data-testid": dataTestId,
}: ErrorBannerProps) {
  return (
    <div
      className={`p-4 rounded-lg bg-red-100 dark:bg-red-900/30 text-red-400 font-mono text-sm dark:text-red-300  ${className}`}
      data-testid={dataTestId}
    >
      <div className="flex items-center justify-between">
        <div>{message}</div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="ml-4 text-red-500 hover:text-red-700 dark:text-red-300 dark:hover:text-red-100"
            aria-label="Dismiss error"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
